import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "./LandingPage.module.css";
import { Button, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import growthImage from "./assets/growthImage.webp";
import termsOfUse from "./assets/termsOfUse.jpg";
import disclaimer from "./assets/disclaimer.webp";
import contactBg from "./assets/contactBg.webp";
import privacyPolicy from "./assets/privacyPolicy.webp";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useBreakpoints } from "./ResponsiveBreapoints";

const MainComponent = ({ type }) => {
  const navigate = useNavigate();
  const { IsXS, IsSM, IsXL, IsXXL } = useBreakpoints();
  const handleClick = () => {
    navigate("/contact-us");
    window.scrollTo(0, 0);
  };
  const card = [
    {
      title: "INVESTOR CONFERENCES",
      color: "#2a75bb",
      value: "investor",
    },
    {
      title: "NEWSLETTERS",
      color: "#2a75bb",
      value: "newsletters",
    },
    {
      title: "STRATEGIC COMMUNICATIONS",
      color: "#488E35",
      value: "strategic",
    },
    {
      title: "VIDEO CREATION",
      color: "#488E35",
      value: "video",
    },
    {
      title: "TV BROADCAST",
      color: "#488E35",
      value: "tv",
    },
    {
      title: "INVESTOR REALTIONS CONSULTING",
      color: "#905722",
      value: "relations",
    },
    {
      title: "PRE IPO-CONSULTING",
      color: "#905722",
      value: "ipo",
    },
    {
      title: "EXPERT INTRODUCTIONS",
      color: "#905722",
      value: "expert",
    },

    {
      title: "WEBSITE DESIGN",
      color: "#90225B",
      value: "website",
    },
    {
      title: "IR WEBPAGE",
      color: "#90225B",
      value: "webpage",
    },
  ];

  return (
    <Grid
      container
      className={
        type === "contact" ||
        type === "privacy" ||
        type === "terms" ||
        type === "disclaimer"
          ? styles.mainContainerType
          : styles.mainContainer
      }
      sx={{
        backgroundImage:
          type === "contact"
            ? `url(${contactBg}) !important`
            : type === "privacy"
            ? `url(${privacyPolicy}) !important`
            : type === "terms"
            ? `url(${termsOfUse})`
            : type === "disclaimer"
            ? `url(${disclaimer})`
            : `url(${growthImage}) !important`,
      }}
    >
      <Grid size={12} className={styles.subContainer}>
        {type === "contact" ||
        type === "privacy" ||
        type === "terms" ||
        type === "disclaimer" ? (
          <Grid container justifyContent="center" flexDirection="column">
            <Grid className={styles.mainComponentContainer}>
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 1.4,
                  ease: "easeInOut",
                }}
                style={{
                  position: "relative",
                  zIndex: 2,
                }}
                viewport={{ once: true }}
              >
                <Typography className={styles.mainComponentHeading}>
                  {type === "contact"
                    ? "CONTACT US"
                    : type === "privacy"
                    ? "PRIVACY POLICY"
                    : type === "terms"
                    ? "TERMS OF USE"
                    : type === "disclaimer"
                    ? "DISCLAIMER"
                    : ""}
                </Typography>
              </motion.div>
            </Grid>
            <Grid className={styles.centerItem}>
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 1.4,
                  ease: "easeInOut",
                  delay: 0.1,
                }}
                style={{
                  position: "relative",
                  zIndex: 2,
                }}
                viewport={{ once: true }}
              >
                <Typography className={styles.mainComponentText}>
                  {type === "contact" ? (
                    <>
                      <span
                        className={styles.mainComponentMenu}
                        onClick={() => navigate("/")}
                      >
                        Home
                      </span>{" "}
                      /{" "}
                      <span className={styles.mainComponentText}>
                        Contact us
                      </span>
                    </>
                  ) : type === "privacy" ? (
                    <>
                      <span
                        onClick={() => navigate("/")}
                        className={styles.mainComponentMenu}
                      >
                        Home
                      </span>{" "}
                      /{" "}
                      <span className={styles.mainComponentText}>
                        Privacy policy
                      </span>
                    </>
                  ) : type === "disclaimer" ? (
                    <>
                      <span
                        onClick={() => navigate("/")}
                        className={styles.mainComponentMenu}
                      >
                        Home
                      </span>{" "}
                      /{" "}
                      <span className={styles.mainComponentText}>
                        Disclaimer
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </Typography>
              </motion.div>
            </Grid>
          </Grid>
        ) : (
          <Grid container justifyContent="center" rowSpacing={9}>
            <Grid
              size={{ xs: 11, sm: 11, md: 11, lg: 8, xl: 7, xxl: 5 }}
              className={styles.mainComponentContainer}
              ml={IsXS ? "" : 3}
            >
              <Grid container rowSpacing={2}>
                <Grid size={{ xs: 12, sm: 9, md: 8, lg: 8, xl: 8 }}>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{
                      duration: 1.4,
                      ease: "easeInOut",
                    }}
                    style={{
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    <Typography className={styles.mainComponentHeading}>
                      BUILDING BRIDGES TO INVESTMENT SUCCESS
                    </Typography>
                  </motion.div>
                </Grid>

                <Grid size={{ xs: 12, sm: 11, md: 10, lg: 10, xl: 10 }}>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{
                      duration: 1.4,
                      ease: "easeInOut",
                      delay: 0.2,
                    }}
                    style={{
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    <Typography className={styles.mainText} sx={{fontFamily:'Inter-400'}}>
                      JP Capital is an investor relations firm leveraging our
                      growing network of 100,000+ quality investors to help you
                      achieve your goals. From targeted investor conferences and
                      compelling video production for major financial networks
                      to consistent and engaging newsletters, we provide
                      tailored solutions across the entire spectrum of investor
                      communications. Ready to elevate your investor relations?
                      Let’s discuss your needs.
                    </Typography>
                  </motion.div>
                </Grid>
                <Grid size={10}>
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{
                      duration: 1.4,
                      ease: "easeInOut",
                      delay: 0.4,
                    }}
                    style={{
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    <Button
                      className={styles.mainComponentButton}
                      onClick={handleClick}
                    >
                      Contact us{" "}
                      <ArrowForwardIcon className={styles.mainComponentArrow} />{" "}
                    </Button>
                  </motion.div>
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <div className={styles.stockTicker}>
                <ul
                  style={{ marginRight: IsXL ? "15px" : IsXXL ? "90px" : "" }}
                >
                  {card.map((item, index) => (
                    <a
                      href={`#${item.value}`}
                      className={styles.title}
                      onClick={(e) => {
                        e.preventDefault();

                        const target = document.getElementById(item.value);
                        if (target) {
                          const targetPosition =
                            target.getBoundingClientRect().top + window.scrollY;
                          const startPosition = window.scrollY;
                          const distance = targetPosition - startPosition;
                          let startTime = null;

                          const duration = 1000;

                          const easeInOutQuad = (t) => {
                            return t < 0.5
                              ? 2 * t * t
                              : 1 - Math.pow(-2 * t + 2, 2) / 2;
                          };

                          const animation = (currentTime) => {
                            if (startTime === null) startTime = currentTime;
                            const elapsedTime = currentTime - startTime;
                            const progress = Math.min(
                              elapsedTime / duration,
                              1
                            );
                            const easeProgress = easeInOutQuad(progress);

                            window.scrollTo(
                              0,
                              startPosition + distance * easeProgress
                            );

                            if (progress < 1) {
                              requestAnimationFrame(animation);
                            }
                          };

                          requestAnimationFrame(animation);
                        }

                        window.history.replaceState(null, "", `#${item.value}`);
                      }}
                    >
                      <li
                        key={index}
                        className={styles.item}
                        style={{ color: item.color }}
                      >
                        <span className={styles.title}>{item.title}</span>
                      </li>
                    </a>
                  ))}
                </ul>
                <ul
                  aria-hidden="true"
                  style={{ marginRight: IsXL ? "15px" : IsXXL ? "90px" : "" }}
                >
                  {card.map((item, index) => (
                    <a
                      href={`#${item.value}`}
                      className={styles.title}
                      onClick={(e) => {
                        e.preventDefault();

                        const target = document.getElementById(item.value);
                        if (target) {
                          const targetPosition =
                            target.getBoundingClientRect().top + window.scrollY;
                          const startPosition = window.scrollY;
                          const distance = targetPosition - startPosition;
                          let startTime = null;
                          const duration = 1000;
                          const easeInOutQuad = (t) => {
                            return t < 0.5
                              ? 2 * t * t
                              : 1 - Math.pow(-2 * t + 2, 2) / 2;
                          };

                          const animation = (currentTime) => {
                            if (startTime === null) startTime = currentTime;
                            const elapsedTime = currentTime - startTime;
                            const progress = Math.min(
                              elapsedTime / duration,
                              1
                            );
                            const easeProgress = easeInOutQuad(progress);

                            window.scrollTo(
                              0,
                              startPosition + distance * easeProgress
                            );

                            if (progress < 1) {
                              requestAnimationFrame(animation);
                            }
                          };

                          requestAnimationFrame(animation);
                        }

                        window.history.replaceState(null, "", `#${item.value}`);
                      }}
                    >
                      <li
                        key={index}
                        className={styles.item}
                        style={{ color: item.color }}
                      >
                        <span className={styles.title}>{item.title}</span>
                      </li>
                    </a>
                  ))}
                </ul>
              </div>
            </Grid>
            {/* <div className={styles.stockTicker}>
                <div className={styles.listTicker}>
                  {[...card,...card].map((item, index) => (
                    <a href={`#${item.value}`} className={styles.title}>
                    <div
                      key={index}
                      style={{ color: item.color }}
                    >
                      <span className={styles.title}>{item.title}</span>
                    </div>
                    </a>
                  ))}
                </div>
                <div aria-hidden="true" className={styles.listTicker}>
                  {card.map((item, index) => (
                    <a href={`#${item.value}`} className={styles.title}>
                    <div
                      key={index}
                      style={{ color: item.color }}
                    >
                      <span className={styles.title}>{item.title}</span>
                    </div>
                    </a>
                  ))}
                </div>
              </div> */}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default MainComponent;
